export default __webpack_public_path__ + "static/media/hht2_ep3_speaking_04.d7ec9b21.png";